/*
 |--------------------------------------------------------------------------
 | Content toggle module
 |--------------------------------------------------------------------------
 */

/* ========================================================================== *\
 IMPORTS
\* ========================================================================== */

import $ from 'jquery';

/* == END IMPORTS =========================================================== */

/* ========================================================================== *\
 CONSTANTS
\* ========================================================================== */

const
    /**
     * The module name
     * @type {String}
     */
    moduleName = 'content-toggle',
    /**
     * Lookup table for selectors
     * @type {Object}
     */
    selectors = {
        base: `.js-${ moduleName }`,
        container: `.js-${ moduleName }-container`
    };

/* == END CONSTANTS ========================================================= */

/* ========================================================================== *\
 SETUP CONTENT TOGGLE
\* ========================================================================== */

class ContentToggle {
    constructor(container) {
        this.container = container;
    }

    init() {
        this.hideAll();
        this.setDefault();
        this.addEventListeners();
    }

    /**
     * Find the specified default-item and open it on page load
     */
    setDefault() {
        const defaultItem = this.container.find('[data-av-content-toggle-default]');

        if (!defaultItem.length) {
            return;
        }

        const defaultItemTitle = defaultItem.attr('data-av-content-toggle-button');
        this.open(defaultItemTitle);
    }

    /**
     * Add event listeners for toggle-buttons
     */
    addEventListeners() {
        const buttons = this.container.find('[data-av-content-toggle-button]')

        if (!buttons.length) {
            return;
        }

        // loop over the buttons and create the event listener
        buttons.each((index, button) => {
            button.addEventListener('click', (event) => {

                // get rid of the 'focus'-outline
                event.target.blur();

                const title = $(event.target).attr('data-av-content-toggle-button');

                if(!title) {
                    throw new Error('av-content-toggle-button requires an attribute corresponding to the av-onctent-toggle-item attribute.')
                }

                this.open(title);
            });
        })
    }

    /**
     * Open given toggle-item, closes all the others
     * @param {string} title
     */
    open(title) {
        this.hideAll();

        if (title) {
            this.show(title)
        }
    }

    /**
     * Open given toggle-item
     * @param {string} title
     */
    show(title) {
        this.container.find('[data-av-content-toggle-button="' + title + '"]').addClass('is-active')

        // attribute-contains-word selector -> triggers when we're looking for `car` in `house car boat`
        // https://api.jquery.com/attribute-contains-word-selector/
        this.container.find('[data-av-content-toggle-item~="' + title + '"]').removeClass('u-display-none')
    }

    /**
     * Hide all toggle-items
     * @param {string} title
     */
    hideAll() {
        this.container.find('[data-av-content-toggle-button]').removeClass('is-active')
        this.container.find('[data-av-content-toggle-item]').addClass('u-display-none')
    }
}

/* == END SETUP CONTENT TOGGLE ============================================== */

/* ========================================================================== *\
 INITIALIZATION
\* ========================================================================== */

const contentToggleContainers = $(selectors.base);

if (contentToggleContainers.length) {

    // initialize all content toggle containers
    contentToggleContainers.each(function () {
        (new ContentToggle($(this))).init();
    });

}

/* == END INITIALIZATION ==================================================== */